<template>
  <main class="recharge-page" role="main">
    <vue-loading :active.sync="is_loading" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div class="row no-gutters recharge-container">
      <section class="col-lg-8 recharge-details-container">
        <div class="section-heading">
          <h3>Recharge</h3>
        </div>
        <div class="recharge-details">
          <p>Not many people know the LTE mobile number for their SIMs. So please login to the manage area and select "MANAGE" for the product you would like to top up.</p>
          <vue-login            
            redirect="/backend.html"
            @forgotPasswordChangedEvent="forgotPasswordChanged"
          ></vue-login>
          <a v-if="isAuthenticated" type="button" class="btn btn-primary" href="/backend.html">
            Manage Area
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
        </div>
      </section>
      <section class="col-lg-4 recharge-summary-container">
        <div class="product-selector-info recharge-info">
          <div class="section-heading"></div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import store from "@/store";
import VueLogin from "@/components/elements/vue-login.vue";
import { mapGetters } from "vuex";

export default {
  name: "recharge",
  components: {
    "vue-login": VueLogin
  },
  data() {
    return {
      isForgotPassword: false,
      is_loading: false,
      action: false
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isLoading() {
      return store.state.products.is_loading;
    }
  },
  watch: {
    isLoading(value) {
      var self = this;
      self.is_loading = value;
    }
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
    self.isForgotPassword = false;
    self.action = self.$route.query.action || null;
  },
  methods: {
    forgotPasswordChanged() {      
      var self = this;
      self.$log.debug("Handle Forgot Password Changed");
      self.isForgotPassword = !self.isForgotPassword;
    }
  }
};
</script>